import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/ClubeBemVinda";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/clube/bem-vinda")({
  validateSearch: (search: Record<string, unknown>): { session_id?: string } => ({
    session_id: typeof search.session_id === "string" ? search.session_id : undefined,
  }),
  head: () => pageHead({ title: "Bem-vinda ao Clube Braussie", path: "/clube/bem-vinda", noindex: true }),
  component: Page,
});
